import React, { Component } from 'react'
import SearchForm from './search'
import Link from '../utils/link'
import { Logo, Close } from './icons'

class SearchOverlay extends Component {

  _toggleOffSearch = () => {
    document && document.querySelector('body').classList.toggle('search-open')
  }

  render() {

    const { canSearch, list, set, type, postType, propertyType } = this.props

    return (
      <section className='off-canvas-search'>
        <div className={`off-canvas-search__container`}>
          <div className='off-canvas-search__inner'>
            <div className='off-canvas-search__content'>
              <div className='off-canvas-search__logo'>
                <Link to='/' title='Gartland'>
                  <div className='off-canvas-search__logo light-theme'>
                    <Logo color='#000000' />
                  </div>
                  <div className='off-canvas-search__logo dark-theme'>
                    <Logo color='#E7E5E1' />
                  </div>
                </Link>
              </div>
              <SearchForm canSearch={canSearch} list={list} set={set} type={type} postType={postType} propertyType={propertyType} toggleOffSearch={this._toggleOffSearch} />
            </div>
            <div className='off-canvas-search__close' onClick={() => this._toggleOffSearch()}>
              <p className='close'>
                <button className='off-canvas-search__button' >
                  <Close color='#000000' />
                  <Close color='#E7E5E1' />
                  <span>Close</span>
                </button>
              </p>
            </div>
          </div>
        </div>
        <button className='off-canvas-search__close-bg' onClick={() => this._toggleOffSearch()} />
      </section>
    )
  }
}

export default SearchOverlay
